'use client';
import { motion } from 'framer-motion';
import React from 'react';

import SoundToggle from '1_components/SoundToggle/SoundToggle';
import useAudioRoutingStore from 'state/audioRoutingStore';

import PlayPause from './PlayPause/PlayPause';
import ProgressBar from './ProgressBar/ProgressBar';
import VoiceScript from './VoiceScript/VoiceScript';

import S from './VoiceAssistant.module.scss';

export interface VoiceAssistantProps {}

const VoiceAssistant: React.FC<VoiceAssistantProps> = ({ ...rest }) => {
  const { audioChunks } = useAudioRoutingStore();

  if (!audioChunks) return null;

  return (
    <>
      <motion.div className={S.VoiceAssistant} {...rest}>
        <SoundToggle />

        <VoiceScript />

        <PlayPause />

        <ProgressBar />
      </motion.div>
    </>
  );
};

export default VoiceAssistant;
